import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { monitoramentoColumns } from './columns/_columns'
import { AtendimentoList } from '../../../atendimento/core/_models'
import { useT } from '_metronic/i18n/Metronici18n'

export const MonitoramentoTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => monitoramentoColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhum atendimento encontrado'
      description='Revise os filtros aplicados.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum atendimento para monitorar'
      description='Os atendimentos agendados e em andamento aparecem aqui.'
    />
  )

  return (
    <CustomTable<AtendimentoList>
      id='kt_table_monitoramento_atendimento'
      ariaLabel='Monitoramento de atendimentos'
      itemLabel={{ singular: 'atendimento', plural: 'atendimentos' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
